import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectAppointment = state => {
    return selectOwnState(state).appointment
}



// WEBPACK FOOTER //
// ./src/modules/appointment/state/detail/selector.js